import { MASSIVE_N5_GRAMMAR } from './MassiveN5Grammar';
import { MASSIVE_N4_GRAMMAR } from './MassiveN4Grammar';

export const ZEN_GRAMMAR = {
  "N5": MASSIVE_N5_GRAMMAR,
  "N4": MASSIVE_N4_GRAMMAR
};